module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-Italic.30d65cde.ttf";